import {useEffect, useState} from 'react';

export const NARROW_VIEWPORT = '(max-width: 1023px)';

export function useViewportWidth() {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const resized = () => setWidth(window.innerWidth);
        window.addEventListener('resize', resized);
        return () => window.removeEventListener('resize', resized);
    }, []);
    return width;
}

// Layout responds to zoom as well as device width; touch behavior still uses device-detect.
export default function useNarrowViewport() {
    const [narrow, setNarrow] = useState(() => window.matchMedia(NARROW_VIEWPORT).matches);
    useEffect(() => {
        const media = window.matchMedia(NARROW_VIEWPORT);
        const changed = () => setNarrow(media.matches);
        changed();
        if(media.addEventListener) {
            media.addEventListener('change', changed);
            return () => media.removeEventListener('change', changed);
        }
        media.addListener(changed);
        return () => media.removeListener(changed);
    }, []);
    return narrow;
}
